module.exports = __webpack_public_path__ + "d239f156.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/icons/sprites/articleLeasing.svg
// module id = 3257
// module chunks = 21